import {
  ENGINEERING_SYSTEMS_CDN_PATH,
  ENGINEERING_SYSTEMS_LANDING_NAME,
} from '../../../engineering-systems-constants';
import { GalleryListStructure } from '../../../components';

export const VENTILATION_GALLERY_LIST: GalleryListStructure[] = [
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/ventilation/popup/1.jpg/1.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/ventilation/ventilation-1b.jpg/ventilation-1b.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/ventilation/ventilation-1b.jpg/ventilation-1b.jpg`,
    alt: 'Пример установки системы вентиляции',
    name: '1.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/ventilation/popup/2.jpg/2.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/ventilation/ventilation-2b.jpg/ventilation-2b.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/ventilation/ventilation-2b.jpg/ventilation-2b.jpg`,
    alt: 'Пример установки системы вентиляции',
    name: '2.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/ventilation/popup/3.jpg/3.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/ventilation/ventilation-3b.jpg/ventilation-3b.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/ventilation/ventilation-3b.jpg/ventilation-3b.jpg`,
    alt: 'Пример установки системы вентиляции',
    name: '3.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/ventilation/popup/4.jpg/4.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/ventilation/ventilation-4b.jpg/ventilation-4b.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/ventilation/ventilation-4b.jpg/ventilation-4b.jpg`,
    alt: 'Пример установки системы вентиляции',
    name: '4.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/ventilation/popup/5.jpg/5.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/ventilation/ventilation-5b.jpg/ventilation-5b.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/ventilation/ventilation-5b.jpg/ventilation-5b.jpg`,
    alt: 'Пример установки системы вентиляции',
    name: '5.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/ventilation/popup/6.jpg/6.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/ventilation/ventilation-6b.jpg/ventilation-6b.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/ventilation/ventilation-6b.jpg/ventilation-6b.jpg`,
    alt: 'Пример установки системы вентиляции',
    name: '6.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/ventilation/popup/7.jpg/7.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/ventilation/ventilation-7b.jpg/ventilation-7b.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/ventilation/ventilation-7b.jpg/ventilation-7b.jpg`,
    alt: 'Пример установки системы вентиляции',
    name: '7.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/ventilation/popup/8.jpg/8.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/ventilation/ventilation-8b.jpg/ventilation-8b.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/ventilation/ventilation-8b.jpg/ventilation-8b.jpg`,
    alt: 'Пример установки системы вентиляции',
    name: '8.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/ventilation/popup/9.jpg/9.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/ventilation/ventilation-9b.jpg/ventilation-9b.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/ventilation/ventilation-9b.jpg/ventilation-9b.jpg`,
    alt: 'Пример установки системы вентиляции',
    name: '9.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/ventilation/popup/10.jpg/10.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/ventilation/ventilation-10b.jpg/ventilation-10b.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/ventilation/ventilation-10b.jpg/ventilation-10b.jpg`,
    alt: 'Пример установки системы вентиляции',
    name: '10.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/ventilation/popup/11.jpg/11.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/ventilation/ventilation-11b.jpg/ventilation-11b.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/ventilation/ventilation-11b.jpg/ventilation-11b.jpg`,
    alt: 'Пример установки системы вентиляции',
    name: '11.jpg',
  },
  {
    src: `${ENGINEERING_SYSTEMS_LANDING_NAME}/ventilation/popup/12.jpg/12.jpg`,
    srcThumb: `${ENGINEERING_SYSTEMS_CDN_PATH}/ventilation/ventilation-12b.jpg/ventilation-12b.jpg`,
    srcSmall: `${ENGINEERING_SYSTEMS_CDN_PATH}/ventilation/ventilation-12b.jpg/ventilation-12b.jpg`,
    alt: 'Пример установки системы вентиляции',
    name: '12.jpg',
  },
];
